const URLS = {
    LOGIN: '#{API_URL}#/api/auth/login',
    REGISTER: '#{API_URL}#/api/auth/register',
    VERIFY_AUTH_COOKIE: '#{API_URL}#/api/auth/verify',
    RECONNECT: '#{API_URL}#/api/auth/reconnect',
    LOGOUT: '#{API_URL}#/api/auth/logout',

    COMPANY: '#{API_URL}#/api/company',

    PLANS: '#{API_URL}#/api/plan',
    PLAN_GROUPS: '#{API_URL}#/api/plan-group',

    APPLICATION_SERVICES: '#{API_URL}#/api/application-service',
    ACCESS_KEYS: '#{API_URL}#/api/access-key',
    COMPANIES: '#{API_URL}#/api/company'
}

export default URLS
